import(/* webpackMode: "eager" */ "/ui/app/global-error.js")